import React from 'react';
import PropTypes from 'prop-types';

import { Layout, LayoutBlock } from 'components/Layout';
import Container from 'components/Container';

import {
	NavigationPropType,
	PaginatedItemsPropType,
	PromoBlockPropType,
	TagPropType
} from 'propTypes/common';
import { PublicationType } from 'propTypes/entities';
import Catalog from './components/Catalog';
import NewsSlider from './components/NewsSlider';
import { FiltersValuesType } from './propTypes';

const PublicationsTemplate = ({
	menu,
	urlParams,
	publications,
	news,
	meta,
	topPromoBlock,
	tags,
	filtersValues,
	defaultFiltersValues
}) => (
	<Layout {...{ menu, meta, topPromoBlock }}>
		<Container>
			<NewsSlider publications={news} />
		</Container>
		<LayoutBlock>
			<Container>
				<Catalog
					{...{
						meta,
						publications,
						urlParams,
						tags,
						filtersValues,
						defaultFiltersValues
					}}
				/>
			</Container>
		</LayoutBlock>
	</Layout>
);

PublicationsTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	publications: PaginatedItemsPropType.isRequired,
	news: PropTypes.arrayOf(PublicationType),
	urlParams: PropTypes.object.isRequired,
	meta: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired
	}),
	topPromoBlock: PromoBlockPropType,
	tags: PropTypes.arrayOf(TagPropType),
	filtersValues: FiltersValuesType,
	defaultFiltersValues: PropTypes.object
};

export default PublicationsTemplate;
